import React from "react";

const AdminHome = () => {
    return (
        <div>
            <h2>Добро пожаловать в админ‑панель</h2>
            <p>Здесь позже появятся виджеты и быстрые действия.</p>
        </div>
    );
};

export default AdminHome;
